import { AnimatePresence, motion } from "framer-motion";
import debounce from "lodash.debounce";
import { FC, useEffect, useState } from "react";
import styled from "styled-components";

const Button = styled(motion.button)`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.lightGray};
  color: ${({ theme }) => theme.colors.black};
  &:hover {
    background: ${({ theme }) => theme.colors.purple};
    color: ${({ theme }) => theme.colors.white};
  }
`;

const ScrollToTopButton: FC = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const container = document.getElementById("dashboard-scrollable-container");

    const handleScrollButtonVisibility = debounce(() => {
      container?.scrollTop ?? 0 > 300
        ? setShowButton(true)
        : setShowButton(false);
    }, 300);

    container?.addEventListener("scroll", handleScrollButtonVisibility);

    return () =>
      container?.removeEventListener("scroll", handleScrollButtonVisibility);
  }, []);

  const onClick = () => {
    const container = document.getElementById("dashboard-scrollable-container");

    container?.scrollTo({
      left: 0,
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <AnimatePresence>
      {showButton && (
        <Button
          onClick={onClick}
          initial={{ scale: 0, opacity: 0.3 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0.3 }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.28214 11.4288C6.89765 11.8253 6.90735 12.4584 7.30381 12.8429C7.70028 13.2274 8.33337 13.2177 8.71786 12.8212L11 10.468L11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19L13 10.468L15.2821 12.8212C15.6666 13.2177 16.2997 13.2274 16.6962 12.8429C17.0927 12.4584 17.1024 11.8253 16.7179 11.4288L12.7179 7.30428C12.5295 7.11008 12.2705 7.00047 12 7.00047C11.7295 7.00047 11.4705 7.11008 11.2821 7.30428L7.28214 11.4288Z"
              fill="currentColor"
            />
            <path
              d="M8 4H16"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTopButton;
